import { IMenuButton } from '@principle-theorem/editor';
import { MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { BasicMenuButtonComponent } from '../../../menu-bar/basic-menu-button/basic-menu-button.component';
import { AIMenuButtonFilters } from '../ai-menu-button-filters';

export function createTldrButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data: {
      buttonType: 'submenu-detail',
      buttonText: 'TLDR;',
      tooltip: `Creates a short version your text`,
      icon: 'fact_check',
      command: (editor) => editor.chain().focus().aiTldr().focus().run(),
      isDisabledFn: (editor) =>
        AIMenuButtonFilters.disableWithoutTextSelection(editor),
    },
  });
}
